/**
 * Merkt sich im Leser, dass auf diesem Gerät bei einem CTA schon abgestimmt
 * bzw. bewertet wurde (VOTE, RATING — Stufe 1 ohne Backend). Nur eine
 * Bequemlichkeit: kommt der Leser wieder, sieht er gleich den Danke-Zustand.
 * Privates Fenster o. ä. → dann eben ohne Merken, nie ein Fehler.
 */
const schluessel = (id: string) => `scrolly:vote:${id}`;

export const leseGemerkt = (id: string): string[] | null => {
    if (!id) return null;
    try {
        const roh = window.localStorage.getItem(schluessel(id));
        const wert: unknown = roh ? JSON.parse(roh) : null;
        return Array.isArray(wert) ? wert.filter((x): x is string => typeof x === "string") : null;
    } catch {
        return null;
    }
};

export const merke = (id: string, wahl: string[]) => {
    if (!id) return;
    try {
        window.localStorage.setItem(schluessel(id), JSON.stringify(wahl));
    } catch {
        /* ohne Merken weiter */
    }
};

/**
 * Wie lange die Abstimmung nach der Abgabe noch offen stehen bleibt, bevor sie
 * zur schmalen Danke-Zeile zusammenklappt (Jan 27.09.2026: Platz machen fürs
 * nächste Bild, gerade bei Serien).
 */
export const ZUKLAPPEN_NACH_MS = 2500;

const GERAET_SCHLUESSEL = "scrolly:cta-geraet";

/**
 * Feste Kennung DIESES GERÄTS für CTA-Abgaben (Benedikts Befund 27.09.2026:
 * die Leser-Kennung der View-Zählung liegt im sessionStorage und gilt nur pro
 * Tab — ein neuer Tab wäre eine neue Stimme). Liegt im localStorage und bleibt,
 * bis der Leser seine Websitedaten löscht. Zufällig, ohne Personenbezug.
 * Ohne Speicher (privates Fenster) gibt es pro Aufruf eine neue — dann zählt
 * die Stimme eben wie die eines neuen Geräts.
 */
export const ctaGeraeteId = (): string => {
    const neu = () =>
        typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
            ? crypto.randomUUID()
            : `g-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
    try {
        const da = window.localStorage.getItem(GERAET_SCHLUESSEL);
        if (da) return da;
        const id = neu();
        window.localStorage.setItem(GERAET_SCHLUESSEL, id);
        return id;
    } catch {
        return neu();
    }
};
